export default "\n<div (click)=\"onClick($event)\" class=\"c-button\"><i class=\"fas fa-external-link-alt pointer\"></i></div>";